import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/gy-apartment'

let api = {
  // 添加支付宝账户
  addAliAccount: `${baseUrl}/aliAccount/add`,

  // 添加支付宝账户
  updateAliAccount: `${baseUrl}/aliAccount/update`,

  // 删除支付宝账户
  deleteAliAccountByCodes: `${baseUrl}/aliAccount/deleteByCodes`,

  // 获取单个支付宝账户信息
  getAliAccountByCode: `${baseUrl}/aliAccount/getByCode`,

  // 获取支付宝账户列表
  getAliAccountList: `${baseUrl}/aliAccount/getList`,

  // 获取支付宝账户分页
  getAliAccountPage: `${baseUrl}/aliAccount/getPage`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/ConfigAli.js